module.exports = __webpack_public_path__ + "static/media/20ECE9.189fdae4.jpg";